import React, { memo, useCallback, useMemo } from 'react'
import { TransferItem } from '../../model/types/types'
import { setJsonSettings } from '../../../../../store/session/actions'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { saveJsonSettings } from '../../../../../store/session/action-creators'
import { getJsonSettingsByKey } from '../../model/selectors/store'
import { useAppDispatch } from '../../../../../hooks/useAppDispatch/useAppDispatch'
import { SortableItemsSelector, SortableItem } from '../../../../../components/sortable-items-selector'

interface TableSettingsModalProps {
  className?: string
  isOpen?: boolean
  onCancel?: () => void
  items: TransferItem[]
}

const TableSettingsModal: React.FC<TableSettingsModalProps> = props => {
  const { isOpen, onCancel, items } = props
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()
  const jsonSettings = useSelector(state => getJsonSettingsByKey(state, pathname))

  const sortableItems: SortableItem[] = useMemo(
    () =>
      items
        .filter(item => {
          if (!item.title) return false
          if (typeof item.title !== 'string') return true
          return item.title.trim() !== ''
        })
        .map(item => ({
          key: item.key,
          title: item.title,
        })),
    [items],
  )

  const selectedKeys = useMemo((): string[] => {
    if (!jsonSettings) {
      return sortableItems.map(item => item.key)
    }

    if (Array.isArray(jsonSettings)) {
      return jsonSettings.length > 0 ? (jsonSettings as string[]) : sortableItems.map(item => item.key)
    }

    if (jsonSettings.order && jsonSettings.order.length > 0) {
      return jsonSettings.order as string[]
    }

    return sortableItems.map(item => item.key)
  }, [jsonSettings, sortableItems])

  const handleSave = useCallback(
    (selectedKeys: string[]) => {
      const currentSettings = jsonSettings || {}
      const widths = Array.isArray(currentSettings) ? {} : currentSettings.widths || {}

      dispatch(
        setJsonSettings({
          [pathname]: {
            order: selectedKeys,
            widths: widths,
          },
        }),
      )
      dispatch(saveJsonSettings())
      onCancel?.()
    },
    [jsonSettings, pathname, dispatch, onCancel],
  )

  return (
    <SortableItemsSelector
      visible={isOpen || false}
      title="Выберите столбцы для отображения"
      availableItems={sortableItems}
      selectedItemKeys={selectedKeys}
      leftPanelTitle="Скрытые столбцы"
      rightPanelTitle="Видимые столбцы"
      emptyLeftText="Все столбцы добавлены"
      emptyRightText="Выберите столбцы для отображения"
      emptyRightDescription="Нажмите на столбец для добавления"
      showSearch={true}
      width={1000}
      onOk={handleSave}
      onCancel={() => onCancel?.()}
    />
  )
}

export default memo(TableSettingsModal)
